import React from "react";
import { PostBodyWithEmbeds } from "../../Community/youtubeEmbed";
import "./VideoDescriptionBody.css";

/**
 * Streaming Video Short / Long / Details body renderer.
 * Reuses Community PostBodyWithEmbeds (linkify + YouTube/Vimeo + WebsiteLinkPreview).
 * Text is React-escaped (no unsanitized HTML). Preview comes from videos/view payload.
 */
export default function VideoDescriptionBody({
  text,
  linkPreview = null,
  className = "video-description-body",
}) {
  const raw = text == null ? "" : String(text);
  if (!raw) {
    return null;
  }

  return (
    <PostBodyWithEmbeds
      text={raw}
      linkPreview={linkPreview || null}
      className={className}
    />
  );
}
